import {
  PaymentTransfersNestedQuery,
  PaymentsDataCollectionQuery,
} from 'generated/resources/graphql'

import type { MappedTransferChild } from './usePaymentNestedTransfers'
import type { MappedPaymentRequestChild } from './usePaymentNestedPaymentRequests'

export type PaymentBase =
  PaymentsDataCollectionQuery['banking']['paymentsConnection']['edges'][number]['node']

export type Payment = PaymentBase | MappedTransferChild | MappedPaymentRequestChild

export type TransferNode = NonNullable<
  NonNullable<PaymentTransfersNestedQuery['banking']['transfersConnection']['edges']>[number]
>['node']

/**
 * Type guard to check if an item is a PaymentBase (not a transfer or payment request)
 */
export function isPaymentBase(item: Payment): item is PaymentBase {
  return !('_isTransfer' in item) && !('_isPaymentRequest' in item)
}

/**
 * Type guard to check if an item is a MappedPaymentRequestChild
 */
export function isMappedPaymentRequestChild(item: Payment): item is MappedPaymentRequestChild {
  return '_isPaymentRequest' in item && item._isPaymentRequest === true
}
